export default {
  setOnline(store: any, payload: boolean) {
    store.commit('SET_ONLINE_STATE', payload);
  },
  scannerInput(store: any, payload: string) {
    store.commit('SCANNER_VALUE', payload);
  },
  scannerConnected(store: any, payload: boolean) {
    store.commit('SCANNER_CONNECTED', payload);
  }
};
